import { StructuredText, StructuredTextDocument } from "react-datocms";
import { useTranslation } from "react-i18next";
import { Content } from "shared/request/myHealthyAdvantageApi";
import { ModalBody, ModalFooter } from "shared/UI/Modal/Modal";
import Button from "shared/UI/Buttons/Button";

export type MiniHealthCheckQuestionnaireIntroProps = {
  intro: Content;
  onCancel: VoidFunction;
  onNext: VoidFunction;
};

export const MiniHealthCheckQuestionnaireIntro = ({ intro, onNext, onCancel }: MiniHealthCheckQuestionnaireIntroProps) => {
  const { t } = useTranslation();
  return (
    <>
      <ModalBody>
        <div className="h-80">
          <StructuredText data={intro as StructuredTextDocument} />
        </div>
      </ModalBody>
      <ModalFooter>
        <Button text={t("navigation.nextButton")} onClick={onNext} />
        <Button variant="text" text={t("navigation.cancelButton")} onClick={onCancel} />
      </ModalFooter>
    </>
  );
};
